import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import K1AnalyticsView from "@/features/K1Dashboard/views/AnalyticsView";

export default function K1Analytics() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Analytics");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <K1AnalyticsView />
      </main>
    </K1DashboardProvider>
  );
}
